import { RowNode } from "@ag-grid-community/core";
import { ICellRendererParams } from "@ag-grid-community/core";
import { FormControl } from "@angular/forms";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { GridActionsService } from '../../data-grid/grid-actions.service';
import { AmountInShipmentOutput } from "../amount-in-shipment-cell-renderer/amount-in-shipment.model";
import { ShipyardService } from "src/app/modules/shipyard/shipyard.service";
import { PurchasingService } from "src/app/modules/planyard/purchasing.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SnackbarComponent } from "src/app/components/snackbar/snackbar.component";

@Component({
  selector: "app-sg-sku-qty-cell-renderer",
  templateUrl: "./sg-sku-qty-cell-renderer.component.html",
  styleUrls: ["./sg-sku-qty-cell-renderer.component.scss"],
})
export class SgSkuQtyCellRendererComponent implements OnDestroy {
  params: any;
  amount: FormControl = new FormControl();
  parentNode: RowNode;
  private destroy$ = new Subject<void>();
  isPurchasingQueue:boolean = false;
  isSelectAmount:boolean = false;
  constructor(public gridActionsService: GridActionsService,
    public shipyardService: ShipyardService,
    public purchasingService:PurchasingService,
    private snackbar: MatSnackBar,) {}

  agInit(params: any): void {
    this.params = params;
    if(params.data[params.props]){
      if(params['isPurchasingQueue']){
        this.isPurchasingQueue = params['isPurchasingQueue'];
      }else{
        this.isPurchasingQueue = false;
      }
    }     
   // this.setPreviousSelectionCount();
    this.parentNode = params.data.parentNode;
    if (this.params.data.SelectedQty) {
      this.amount.setValue(this.params.data.SelectedQty)
    }
    this.amount.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((e) => {
      if(e !== undefined && this.params.data.SelectedQty != e){
        this.params.data.SelectedQty = e;
        if(params.data[params.props] && !this.isPurchasingQueue || this.isSelectAmount)
        this.amountChanged(e);
        if (this.params.callbackFunction && !this.isPurchasingQueue || this.isSelectAmount) {
          const output: AmountInShipmentOutput = {
            value: this.amount.value,
            node: this.params.node
          }
          this.params.callbackFunction(output);
        }
        this.isSelectAmount = false;
      }
    });
    if(this.isPurchasingQueue){
      if(this.params.data?.QueueQty != null){
        this.amount.setValue(this.params.data?.QueueQty)
        let index = this.shipyardService.subSkusToAddToShipment.findIndex((res)=> res.sku.AccountSkuId == this.params.data.AccountSkuId);
        if(index == -1){
          this.shipyardService.subSkusToAddToShipment.push({qty:this.params.data.QueueQty,sku:this.params.data})
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  selectSuggestedAmount(e: MouseEvent, amount) {
    this.isSelectAmount = true;
    e.stopPropagation();
    if (this.amount.value !== amount && amount > 0) {
      this.amount.setValue(amount);
    } else {
      this.amount.reset();
    }
  }

  refresh(params: ICellRendererParams) {
    this.amount.markAsTouched();
    this.amount.setValue(this.params.data.SuggestedQty ? this.params.data.Suggested: null, { emitEvent: false });
    return true;
  }

  setPreviousSelectionCount() {
    const index = this.getIndexInArray();
    if (index !== -1) {
      const qty = this.shipyardService.subSkusToAddToShipment[index].qty;
      if (qty) {
        this.amount.setValue(qty);
        this.params.data.SelectedQty = qty;
        if (this.params.callbackFunction) {
          const output: AmountInShipmentOutput = {
            value: this.amount.value,
            node: this.params.node
          }
          this.params.callbackFunction(output);
        }
      }
      this.params.node.setSelected(true);
    }
  }

  amountChanged(e) {
    const obj = { sku: this.params.data, qty: e };
    const index = this.getIndexInArray();

    if (index === -1) {
      if (e >= 1) this.shipyardService.subSkusToAddToShipment.push(obj);
      if (this.isPurchasingQueue) this.selectedValueChanged(e);
    } else if (!e) {
      this.shipyardService.subSkusToAddToShipment.splice(index, 1);
      if (this.isPurchasingQueue) this.removeShipmentFromQUeue()
    } else {
      this.shipyardService.subSkusToAddToShipment[index].qty = e;
      if (this.isPurchasingQueue) this.selectedValueChanged(e);
    }
  }

  getIndexInArray() {
      return this.shipyardService.subSkusToAddToShipment
        .map((e) => e.sku.AccountSkuId)
        .indexOf(this.params.data.AccountSkuId);   
  }

  selectedValueChanged(e){
    let itemId = this.params.node.data.parentNode.data.ItemId;
      if(e){
        const payload={
          skus:[{
            qty: e,
            accountSkuId:this.params.data.AccountSkuId,
            itemId:itemId 
          }]
        }
        this.shipyardService.purchasingQueueCount += 1;
        this.purchasingService.createPurchasingQueue(payload).subscribe({
          next:(res:any)=>{           
            this.purchasingService.updatePurchasingQueueCount.next(true);
          },
          error:(err)=>{
            this.snackbar.openFromComponent(SnackbarComponent,
              {
                duration: 3000,
                horizontalPosition: 'center',
                data: {
                  title: err.error?.error[0],
                  action: 'Dismiss',
                  type: 'error',
                },
              }
            );
          }
        })
      }
  }

  removeShipmentFromQUeue(){
    let itemId = this.params.node.data.parentNode.data.ItemId;
    const payload={
      removeSku: [
        {
          itemId: itemId,
          accountSkuId: this.params.data.AccountSkuId
        }
      ]
    }
    this.purchasingService.RemovePurchasingQueue(payload).pipe(takeUntil(this.destroy$))
    .subscribe({
      next:(res)=>{
        this.purchasingService.updatePurchasingQueueCount.next(true);
      },
      error:(err)=>{
        this.snackbar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: err.error?.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
      }
    })
  }

  valueChange(event){
    if (this.isPurchasingQueue) {
      if (this.params.callbackFunction) {
        const output: AmountInShipmentOutput = {
          value: this.amount.value,
          node: this.params.node
        }
        this.params.callbackFunction(output);
      }
      this.amountChanged(Number(event.target.value));
    }
  }
}
